var uiCursorPagination = {
	caption: "Cursor paginering",
	first: "Eerste pagina",
	previous: "Vorige pagina",
	next: "Volgende pagina"
};
var nl = {
	uiCursorPagination: uiCursorPagination
};

export { nl as default, uiCursorPagination };
